function WordOfTheDayPage(){
    return <div>
        <div>
            Word of the day
        </div>
    </div>
}

export default WordOfTheDayPage;